export default "__VITE_ASSET__BLC6jB5p__"